import { State } from "state/state_system/State";
import { stateProperty } from "state/state_system/StateProperty";
import { StateMap } from "state/state_system/StateMap";
import { createStateFromInterface } from "state/state_system/CreateStateFromInterface";
import { fetch } from "utilities";

interface LlmResponseData {
    id: number;
    rating: LlmResponseRating;
    comment: string | null;
    draft_response: string;
    draft_summary: string;
}

export type LlmResponseRating = "not_rated" | "bad" | "good";

export class LlmResponse extends createStateFromInterface<LlmResponseData>() {
    @stateProperty id: number;
    @stateProperty rating: LlmResponseRating = "not_rated";
    @stateProperty comment: string | null;

    async update(): Promise<void> {
        await fetch(`/llm_responses/${this.id}`, {
            method: "PATCH",
            body: JSON.stringify({ id: this.id, rating: this.rating, comment: this.comment ? this.comment : null }),
            headers: {
                "Content-type": "application/json",
                Accept: "application/json",
            },
        });
    }

    toggleRating(rating: LlmResponseRating): void {
        if (this.rating === rating) {
            this.rating = "not_rated";
            this.comment = null;
        } else {
            this.rating = rating;
        }
    }
}

class LlmResponseState extends State {
    @stateProperty private byId = new StateMap<number, LlmResponse>();

    private async fetch(id: number): Promise<LlmResponse> {
        const url = `/llm_responses/${id}.json`;
        const response = await fetch(url);
        const data = await response.json();
        this.byId.set(id, new LlmResponse(data));
        return this.byId.get(id);
    }

    get(id: number): LlmResponse {
        if (!this.byId.has(id)) {
            this.fetch(id);
        }
        return this.byId.get(id);
    }
}

export const llmResponseState = new LlmResponseState();
